import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import vw from 'styles/utils';

function CloseButton(props) {
  const { onClick } = props;

  return (
    <Root onClick={onClick} {...props}>
      <span />
      <span />
    </Root>
  )
}

CloseButton.propTypes = {
  onClick: PropTypes.func
}

const Root = styled.button`
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;

  ${vw('top', 10, 25, 30)}
  ${vw('right', 10, 25, 30)}
  ${vw('width', 10, 25, 11)}
  ${vw('height', 10, 25, 11)}

  > span {
    height: 2px;
    width: 100%;
    background: #0068B7;
    display: block;
    position: absolute;
    transition: all 0.25s;

    &:nth-of-type(1) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
    }
    &:nth-of-type(2) {
      top: 50%;
      transform: translateY(-50%) rotate(-45deg);
    }
  }
`;

export default CloseButton
